import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>CivilCADPro</h3>
          <p>Complete survey toolkit for AutoCAD</p>
          <p>Launching 15 August 2026</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <a href="#home">Home</a>
          <a href="#features">Features</a>
          <a href="#how-it-works">How It Works</a>
          <a href="#demo">Free Trial</a>
        </div>
        
        <div className="footer-section">
          <h4>Contact</h4>
          <p>📞 9564743480</p>
          <p>📍 India</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>© 2026 CivilCADPro. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;